export default __webpack_public_path__ + "static/media/Client App.705ba4fe.jpg";